<template>
    <div class="top">
        <div class="content">
            <div class="logo" @click.stop="gotoHome"></div>
            <div class="menu">
                <span @click="goMy()">我</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    methods: {
        goMy(){
           this.$router.replace('/my')
        },
        gotoHome() {
            this.$router.replace('/')
        }
    }
}
</script>
<style scoped lang="less">
.top {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 44px;
    z-index: 30;
    background: rgba(0, 0, 0, 0.6);
    box-shadow: 0 8px 32px 0 rgba(251, 251, 252, 0.37);
    backdrop-filter: blur(17.5px);
    -webkit-backdrop-filter: blur(17.5px);
    display: flex;
    align-items: center;
    justify-content: left;

    .content {
        width: 80%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .menu {
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: left;
            span{
                cursor: pointer;
            }
        }

        .logo {
            margin-left: 5px;
            cursor: pointer;
            pointer-events: all;
            width: 40px;
            height: 33px;
            background: url("../../public/logo.png") no-repeat;
            background-size: contain;

        }
    }
}

</style>
